import React, { useEffect, useState } from "react";
import {
	Grid,
	Typography,
	Button,
	TextField,
	MenuItem,
	Table,
	TableBody,
	TableCell,
	TableContainer,
	TableHead,
	TableRow,
	Paper,
	TablePagination,
	Dialog,
	DialogActions,
	DialogContent,
	DialogContentText,
	DialogTitle
} from "@mui/material";
// import { makeStyles } from "@mui/styles";
import { makeStyles } from "@mui/styles";
import CustomButton from "../../../src/components/CustomButton/CustomButton";
import Layout from "../../components/Wrappers/Layout";
import { Card, Alert } from "reactstrap";
// import { AiOutlineSearch } from "react-icons/ai";
// import { AiOutlineUserAdd } from "react-icons/ai";
// import { AiOutlineFileAdd } from "react-icons/ai";
import { useSelector, useDispatch } from "react-redux";
import {
	resetGetManualOtpList,
	getManualOtpList
} from "../../redux/actions/getManualOtpListAction";

import success from "../../assets/img/success.png";
// import SearchIcon from "@mui/icons-material/Search";
import SearchIcon from "@mui/icons-material/Search";
import {
	closedManualOtpRequestList,
	resetClosedManualOtpRequestList
} from "../../redux/actions/closedManualOtpRequestAction";
// import CloseIcon from "@mui/icons-material/Close";
import CloseIcon from "@mui/icons-material/Close";
import LoadingSpinner from "../../components/LoadingSpinner/LoadingSpinner";
import "../../components/LoadingSpinner/spinner.css";

// import Tooltip from "@mui/material/Tooltip";
// import BackButton from "../../components/BackButton/BackButton";
import Util from "../../validation";
import SOLogout from "../../components/Logout/SOLogout";
import regenerateToken from "../../components/RegenerateToken/regenerateToken";
import NotificationPopups from "../../NotificationPopup/NotificationPopups";

//new
import {
	getRegenerateToken,
	resetRegenerateToken,
  } from "../../redux/actions/regenerateTokenAction";


const useStyles = makeStyles({
	table: {
		minWidth: 650
	}
});

const ManualOTP = () => {
	const [requestType, setRequestType] = useState("SignUp");
	const [statusType, setStatusType] = useState("All");
	const [mobileNumber, setMobileNumber] = useState("");
	const [emailId, setEmailId] = useState("");
	const [getManualOtpListStatus, setGetManualOtpListStatus] = useState(false);
	const [getManualOtpListArray, setGetManualOtpListArray] = useState([]);
	const [notificationOpen, setNotificationOpen] = React.useState(false);
	const [isLoading, setIsLoading] = useState(false);
	//closedManualOtpRequestListRes
	const [
		closedManualOtpRequestListStatus,
		setClosedManualOtpRequestListStatus
	] = useState(false);

	const [closedManualOtpRequestListArray, setClosedManualOtpRequestListArray] =
		useState([]);

	const [rowsPerPage, setRowsPerPage] = useState(5);

	const [page, setPage] = useState(0);
	const classes = useStyles();

	const dispatch = useDispatch();
	// const partnerloginUser = useSelector(({ login }) => login);
	// var authToken = partnerloginUser.data.AuthToken;

	const regenerateTokenRes = useSelector(
		({ regenerateToken }) => regenerateToken
	);
	// console.log("regenerateTokenRes", regenerateTokenRes);
	var authToken = regenerateTokenRes.data.AuthToken;

	const handleNoticationClose = () => {
		setNotificationOpen(false);
	};

	const handleChangePage = (event, newPage) => {
		setPage(newPage);
	};

	// const handleChangeRowsPerPage = (event) => {
	// 	setRowsPerPage(parseInt(event.target.value, 10));
	// 	setPage(0);
	// };
	const handleChangeRowsPerPage = (event) => {
        const newRowsPerPage = parseInt(event.target.value, 10);
        const currentFirstRowIndex = page * rowsPerPage;
        const newPage = Math.floor(currentFirstRowIndex / newRowsPerPage);
   
        setRowsPerPage(newRowsPerPage);
        setPage(newPage);
    };

	const getManualOtpListRes = useSelector(
		({ getManualOtpList }) => getManualOtpList
	);

	const closedManualOtpRequestListRes = useSelector(
		({ closedManualOtpRequestList }) => closedManualOtpRequestList
	);

	// console.log(getManualOtpListRes + "getManualOtpListRes");

	const handleChange = ({ target: { name, value } }) => {
		if (name === "statusType") {
			setStatusType(value);
		}

		if (name === "requestType") {
			setRequestType(value);
		}

		if (name === "emailId") {
			setEmailId(value);
		}

		if (name === "mobileNumber") {
			// setMobileNumber(value);
			Util.verifyMobile(value)
				? setMobileNumber(value)
				: setMobileNumber(mobileNumber);
		}
	};

	const getManualListRequest = () => {
		setGetManualOtpListStatus(true);
		setIsLoading(true);
		const getManualList = {
			loginDetails: {
				walletOwnerId: regenerateTokenRes.data.partnerId || ""
			},
			actionCustomerMasterRequestVO: {
				requestType: requestType,
				otpStatus: statusType == "All" ? "1" : statusType,
				email: emailId,
				phoneNo: mobileNumber
			}
		};

		return dispatch(getManualOtpList(getManualList, authToken));
	};

	useEffect(() => {
		if (regenerateTokenRes.data.status == "success") {
			getManualListRequest();
		}
	}, [regenerateTokenRes.data.status]);
	useEffect(() => {
		dispatch(resetGetManualOtpList())
	}, [])

	const getManualOtpListStatusFunc = () => {
		if (getManualOtpListStatus) {
			if (getManualOtpListRes.data.status == "Success") {
				setIsLoading(false);
				setGetManualOtpListArray(
					[].concat(
						getManualOtpListRes.data.customerMasterDetailsKYCResponseVOList
					)
				);
			}
			if (getManualOtpListRes.data.status == "Failed") {
				NotificationPopups( "error", "Failed", getManualOtpListRes.data.description )
				setIsLoading(false);
				setGetManualOtpListArray(getManualOtpListRes.data);
				if (
					getManualOtpListRes.data.description == "session out"
				) {
					SOLogout(dispatch, authToken, regenerateTokenRes.data.partnerId);
				}
				if (
					getManualOtpListRes.data.description == "Authorization failed"
				) {
					regenerateToken(dispatch, authToken, regenerateTokenRes.data.partnerId);
				}
			}
			if (getManualOtpListRes.data.status == "failed") {
				NotificationPopups( "error", "Failed", getManualOtpListRes.data.description )
				setIsLoading(false);
				setGetManualOtpListArray(getManualOtpListRes.data);
				if (
					getManualOtpListRes.data.description == "session out"
				) {
					SOLogout(dispatch, authToken, regenerateTokenRes.data.partnerId);
				}
				if (
					getManualOtpListRes.data.description == "Authorization failed"
				) {
					regenerateToken(dispatch, authToken, regenerateTokenRes.data.partnerId);
				}
			}
			if (getManualOtpListRes.data.status == "Not Found" || 
			getManualOtpListRes.data.status == "NOT FOUND" ) {
			NotificationPopups( "error", "Failed", getManualOtpListRes.data.description )
		}
		}
	};

	useEffect(() => {
		if (getManualOtpListRes.data.status == "Success") {
			setPage(0);
		}
	}, [getManualOtpListRes.data.status]);

	useEffect(() => {
		getManualOtpListStatusFunc();
	}, [getManualOtpListRes.data.status]);

	useEffect(() => {
		if (getManualOtpListRes.data.status == "Success") {
			setPage(0);
		}
	}, [getManualOtpListRes.data.status]);

	const closedManualOtpRequest = (
		customerId,
		requestType,
		customerEmail,
		userName
	) => {
		setClosedManualOtpRequestListStatus(true);
		const updateCustomerDetailsReq = {
			loginDetails: {
				walletOwnerId: regenerateTokenRes.data.partnerId || ""
			},
			actionCustomerMasterRequestVO: {
				customerId: customerId,
				requestType: requestType,
				email: customerEmail,
				phoneNo: userName
			}
		};
		return dispatch(
			closedManualOtpRequestList(updateCustomerDetailsReq, authToken)
		);
	};

	const closedManualOtpRequestListStatusFunc = () => {
		if (closedManualOtpRequestListStatus) {
			if (closedManualOtpRequestListRes.data.status == "Success") {
				getManualListRequest();
				setClosedManualOtpRequestListArray(closedManualOtpRequestListRes.data);
				setNotificationOpen(true);
			}
			if (closedManualOtpRequestListRes.data.status == "Failed") {
				setClosedManualOtpRequestListArray(closedManualOtpRequestListRes.data);
				setNotificationOpen(true);
				if (
					closedManualOtpRequestListRes.data.description == "session out"
				) {
					SOLogout(dispatch, authToken, regenerateTokenRes.data.partnerId);
				}
				if (
					closedManualOtpRequestListRes.data.description == "Authorization failed"
				) {
					regenerateToken(dispatch, authToken, regenerateTokenRes.data.partnerId);
				}
			}
			if (closedManualOtpRequestListRes.data.status == "failed") {
				setClosedManualOtpRequestListArray(closedManualOtpRequestListRes.data);
				setNotificationOpen(true);
				if (
					closedManualOtpRequestListRes.data.description == "session out"
				) {
					SOLogout(dispatch, authToken, regenerateTokenRes.data.partnerId);
				}
				if (
					closedManualOtpRequestListRes.data.description == "Authorization failed"
				) {
					regenerateToken(dispatch, authToken, regenerateTokenRes.data.partnerId);
				}
			}
		}
	};

	useEffect(() => {
		closedManualOtpRequestListStatusFunc();
	}, [closedManualOtpRequestListRes.data.status]);

	return (
		<>
			<Layout>
				<Card>
					{/* <BackButton /> */}
					<Grid
						container
						spacing={2}
						style={{ padding: "25px", marginTop: "2rem" }}
					>
						<Grid item xs={12} sm={12} md={3} lg={3}>
							<TextField
								select
								autoFocus
								margin="dense"
								id="name"
								label="Select Request Type"
								type="name"
								fullWidth
								variant="standard"
								name="requestType"
								value={requestType || ""}
								onChange={handleChange}
								InputProps={{
									sx: {
									  "&:before": { borderBottomColor: "gray" }, // before focus
									  "&:after": { borderBottomColor: "gray" },  // after focus
									},
								  }}
								  InputLabelProps={{
									sx: { color: 'gray' }, // Optional: if you want the label to be white
								  }}
							>
								<MenuItem value="SignUp">Sign Up</MenuItem>
								<MenuItem value="NewDevice">New Device</MenuItem>
							</TextField>
						</Grid>
						<Grid item xs={12} sm={12} md={3} lg={3}>
							<TextField
								autoFocus
								margin="dense"
								id="name"
								label="Email"
								type="text"
								fullWidth
								variant="standard"
								value={emailId || ""}
								name="emailId"
								onChange={handleChange}
								InputProps={{
									sx: {
									  "&:before": { borderBottomColor: "gray" }, // before focus
									  "&:after": { borderBottomColor: "gray" },  // after focus
									},
								  }}
								  InputLabelProps={{
									sx: { color: 'gray' }, // Optional: if you want the label to be white
								  }}
							/>
						</Grid>
						<Grid item xs={12} sm={12} md={3} lg={3}>
							<TextField
								autoFocus
								margin="dense"
								id="name"
								label="Mobile No"
								type="tel"
								fullWidth
								variant="standard"
								value={mobileNumber}
								name="mobileNumber"
								onChange={handleChange}
								// InputProps={{
								// 	sx: {
								// 	  "&:before": { borderBottomColor: "gray" }, // before focus
								// 	  "&:after": { borderBottomColor: "gray" },  // after focus
								// 	},
								//   }}
								//   InputLabelProps={{
								// 	sx: { color: 'gray' }, // Optional: if you want the label to be white
								//   }}
								sx={{
									"& .MuiInput-underline:before": {
									  borderBottomColor: "gray", // White color for the underline before focus
									},
									"& .MuiInput-underline:hover:not(.Mui-disabled):before": {
									  borderBottomColor: "gray", // White color on hover
									},
									"& .MuiInput-underline:after": {
									  borderBottomColor: "gray", // White color after focus
									},
								  }}
							/>
						</Grid>
						<Grid item xs={12} sm={12} md={3} lg={3}>
							<TextField
								select
								autoFocus
								margin="dense"
								id="name"
								label="Status"
								type="name"
								fullWidth
								variant="standard"
								name="statusType"
								value={statusType || ""}
								onChange={handleChange}
								InputProps={{
									sx: {
									  "&:before": { borderBottomColor: "gray" }, // before focus
									  "&:after": { borderBottomColor: "gray" },  // after focus
									},
								  }}
								  InputLabelProps={{
									sx: { color: 'gray' }, // Optional: if you want the label to be white
								  }}
							>
								<MenuItem value="All">All</MenuItem>
								<MenuItem value="Pending">Pending</MenuItem>
								<MenuItem value="Closed">Closed</MenuItem>
							</TextField>
						</Grid>
					</Grid>

					<Grid
						container
						style={{
							padding: "10px",
							marginTop: "1.5rem",
							marginBottom: "15px"
						}}
					>
						<Grid item md={5}>
							<CustomButton
								style={{
									padding: "8px"
								}}
								onClick={getManualListRequest}
							>
								Search <SearchIcon />
							</CustomButton>
						</Grid>
						<Grid item md={7}></Grid>
					</Grid>
				</Card>

				{isLoading ? (
					<LoadingSpinner />
				) : getManualOtpListArray.length == undefined ||
				  !getManualOtpListStatus ? (
					<Card>
						<Grid
							container
							style={{
								padding: "10px"
							}}
						>
							<Grid xs={12} sm={12} md={12} lg={12}>
								<Typography
									variant="body1"
									style={{ fontWeight: "700" }}
									className="themeText"
								>
									OTP Request Details
								</Typography>
							</Grid>
							<Grid xs={12} sm={12} md={12} lg={12}>
								<Alert
									className="my-3 tableHeaderColor"
									variant="secondary"
									style={{ color: "white" }}
								>
									No Records Found!
								</Alert>
							</Grid>
						</Grid>
					</Card>
				) : (
					<Card>
						<Grid
							container
							style={{
								padding: "10px"
							}}
						>
							<Grid xs={12} sm={12} md={12} lg={12}>
								<Typography
									variant="body1"
									style={{ fontWeight: "700" }}
									className="themeText"
								>
									OTP Request Details
								</Typography>
							</Grid>
							<TableContainer component={Paper} className="my-3">
								<Table
									className={classes.table}
									size="small"
									aria-label="a dense table"
								>
									<TableHead>
										<TableRow className="tableHeaderColor">
											{/* <TableCell
                    align="center"
                    style={{ fontWeight: "bold", color: "white" }}
                  >
                    Sr. No{" "}
                  </TableCell> */}
											<TableCell
												align="center"
												style={{ fontWeight: "bold", color: "white" }}
											>
												{" "}
												Email
											</TableCell>
											<TableCell
												align="center"
												style={{ fontWeight: "bold", color: "white" }}
											>
												{" "}
												Mobile
											</TableCell>
											<TableCell
												align="center"
												style={{ fontWeight: "bold", color: "white" }}
											>
												Status
											</TableCell>
											<TableCell
												align="center"
												style={{ fontWeight: "bold", color: "white" }}
											>
												Email otp
											</TableCell>
											<TableCell
												align="center"
												style={{ fontWeight: "bold", color: "white" }}
											>
												Mobile Otp
											</TableCell>
											<TableCell
												align="center"
												style={{ fontWeight: "bold", color: "white" }}
											>
												Action
											</TableCell>
										</TableRow>
									</TableHead>
									<TableBody>
										{getManualOtpListArray &&
											[]
												.concat(getManualOtpListArray)
												.slice(
													page * rowsPerPage,
													page * rowsPerPage + rowsPerPage
												)
												.map((row, index) => (
													<TableRow key={index}>
														{/* <TableCell>{index + 1}</TableCell> */}

														<TableCell align="center">
															{row.customerEmail}
														</TableCell>
														<TableCell align="center">{row.userName}</TableCell>
														<TableCell align="center">
															{row.requestStatus}
														</TableCell>

														<TableCell align="center">
															{/* {row.emailOtp} */}
															{row.requestStatus == "Closed"
																? "-"
																: row.emailOtp}
														</TableCell>
														<TableCell align="center">
															{/* {row.mobileOtp} */}
															{row.requestStatus == "Closed"
																? "-"
																: row.mobileOtp}
														</TableCell>

														<TableCell align="center">
															{row.requestStatus == "Closed" ? (
																"-"
															) : (
																// <Tooltip title="Close">
																	<CustomButton
																		style={{
																			padding: "8px"
																		}}
																		onClick={() =>
																			closedManualOtpRequest(
																				row.customerId,
																				requestType,
																				row.customerEmail,
																				row.userName
																			)
																		}
																	>
																		{/* Closed */}
																		{
																			<CloseIcon
																				style={{
																					color: "#fff",
																					fontSize: "20px"
																				}}
																			/>
																		}
																	</CustomButton>
																// </Tooltip>
															)}
														</TableCell>
													</TableRow>
												))}
									</TableBody>
								</Table>
								<TablePagination
									rowsPerPageOptions={[5, 10, 25]}
									component="div"
									count={getManualOtpListArray.length}
									rowsPerPage={rowsPerPage}
									page={page}
									onPageChange={handleChangePage}
									onRowsPerPageChange={handleChangeRowsPerPage}
								/>
							</TableContainer>
						</Grid>
					</Card>
				)}

				{closedManualOtpRequestListArray && (
					<div>
						<Dialog open={notificationOpen} onClose={handleNoticationClose}>
							<DialogContent className="text-center popupBackgroundColor">
								<img src={success} alt="" width="100px" className="my-2" />
							</DialogContent>
							<DialogContent>
								<h4
									style={{ margin: "0", fontSize: "15px", textAlign: "center" }}
								>
									{closedManualOtpRequestListArray.description}
								</h4>
							</DialogContent>
							<DialogActions style={{ justifyContent: "center" }}>
								<CustomButton
									style={{
										padding: "8px 16px"
									}}
									onClick={handleNoticationClose}
								>
									Ok
								</CustomButton>
							</DialogActions>
						</Dialog>
					</div>
				)}

				{/* <Card>
          <Grid container style={{ padding: "10px" }}>
            <Typography variant="body1"> </Typography>
            <Grid sm={12} md={12} lg={12}>
              <Alert className="my-3" variant="secondary">
                No Records Found!
              </Alert>
            </Grid>
          </Grid>
        </Card> */}
			</Layout>
		</>
	);
};

export default ManualOTP;
